/**
 * Display formatters. Numeric columns across the app use tabular-nums
 * so these helpers just pick digits + locale. Dashes for null/undefined
 * so empty cells read as "no data" rather than "zero".
 */

export function fmtMoney(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return v.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Money formatter that hides trailing-zero decimals: shows `$10`
 *  rather than `$10.00`, but `$10.50` stays `$10.50`. Use for
 *  user-set amounts (budget / bid) where the trailing `.00` reads
 *  like noise — per user feedback 2026-05-05: "we don't show two
 *  decimals when there are zeros after the comma; only display them
 *  when the user has set a non-integer value." */
export function fmtMoneyTrim(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  // Round to 2 decimals first so floating-point noise (10.0000001)
  // doesn't trigger the decimal display.
  const rounded = Math.round(v * 100) / 100;
  const isInteger = rounded === Math.trunc(rounded);
  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export function fmtInt(v: number | null | undefined): string {
  if (v === null || v === undefined) return "—";
  return v.toLocaleString("en-US");
}

export function fmtPct(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined) return "—";
  return `${v.toFixed(digits)}%`;
}

export function fmtRoas(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined) return "—";
  return `${v.toFixed(digits)}×`;
}
